import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';

import { NotificationListContent } from './notification-list-content/notification-list-content.component';
import { NotificationTabEnum } from './notifications.enum';
import { useNotifications } from './notifications.hook';
import * as Styled from './notifications.style';

interface NotificationsContainerProps {
  isOpen: boolean;
  onClose: () => void;
}

const NotificationsContainer = ({
  isOpen,
  onClose,
}: NotificationsContainerProps) => {
  const { t } = useTranslation();
  const {
    notifications,
    isLoading,
    isFetching,
    activeTab,
    handleTabChange,
    handleMarkAllAsRead,
    isMarkingAllAsRead,
    handleNotificationClick,
  } = useNotifications(onClose);

  if (!isOpen) return null;

  return (
    <>
      <Styled.Overlay onClick={onClose} />
      <Styled.Container isOpen={isOpen}>
        <Styled.Header>
          <Styled.Title>{t('notification_web.title')}</Styled.Title>
          <Styled.MarkAllReadButton
            onClick={handleMarkAllAsRead}
            disabled={isMarkingAllAsRead}
          >
            {isMarkingAllAsRead ? (
              <Spin size="small" />
            ) : (
              t('notification_web.mark_all_read')
            )}
          </Styled.MarkAllReadButton>
        </Styled.Header>

        <Styled.TabsContainer>
          <Styled.Tab
            isActive={activeTab === NotificationTabEnum.ALL}
            onClick={() => handleTabChange(NotificationTabEnum.ALL)}
          >
            {t('notification_web.tab_all')}
          </Styled.Tab>
          <Styled.Tab
            isActive={activeTab === NotificationTabEnum.UNREAD}
            onClick={() => handleTabChange(NotificationTabEnum.UNREAD)}
          >
            {t('notification_web.tab_unread')}
          </Styled.Tab>
        </Styled.TabsContainer>

        <Styled.NotificationList>
          <NotificationListContent
            notifications={notifications}
            isLoading={isLoading || isFetching}
            onNotificationClick={handleNotificationClick}
            emptyTitle={t('notification_web.empty_title')}
            emptyDescription={t('notification_web.empty_description')}
          />
        </Styled.NotificationList>
      </Styled.Container>
    </>
  );
};

export { NotificationsContainer };
